import { ContentDisplay } from "@/components/ContentDisplay";
import { MultiSectionDisplay } from "@/components/MultiSectionDisplay";
import { X } from "@phosphor-icons/react";
import { isMultiSectionDraft, parseDraftToSections } from "@/lib/generateConstants";

export function HistoryViewModal({ viewItem, onClose, onRepurpose }) {
  if (!viewItem) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm overflow-y-auto">
      <div className="max-w-4xl mx-auto px-4 py-4 sm:py-8">
        <div className="flex items-start justify-between mb-4 sm:mb-6">
          <div className="min-w-0 flex-1">
            <h2 className="font-['Cormorant_Garamond'] text-xl sm:text-2xl font-bold text-[var(--text-primary)] break-words pr-2">
              {viewItem.title || viewItem.topic}
            </h2>
            <div className="flex flex-wrap items-center gap-2 mt-1">
              <span className="text-xs text-[#FF4400] font-['JetBrains_Mono']">{viewItem.content_type}</span>
              <span className="text-xs text-[var(--text-muted)]">·</span>
              <span className="text-xs text-[var(--text-muted)]">{viewItem.platform}</span>
              <span className="text-xs text-[var(--text-muted)]">·</span>
              <span className="text-xs text-[var(--text-muted)]">{viewItem.ai_model_used}</span>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2.5 sm:p-2 rounded-md text-[var(--text-secondary)] hover:text-[var(--text-primary)] hover:bg-[var(--bg-hover)] transition-colors shrink-0"
            data-testid="close-view-modal"
          >
            <X size={24} />
          </button>
        </div>

        {isMultiSectionDraft(viewItem.generated_draft, viewItem.content_type) ? (
          <MultiSectionDisplay
            data={parseDraftToSections(viewItem.generated_draft || "")}
            isSaved={true}
            exportMeta={{ title: viewItem.title || viewItem.topic, content_type: viewItem.content_type, platform: viewItem.platform, audience: viewItem.audience, ai_model: viewItem.ai_model_used }}
            generationContext={{ content_type: viewItem.content_type, topic: viewItem.topic, platform: viewItem.platform, tone: (viewItem.tone_variations || []).join(", ") }}
            aiModel={viewItem.ai_model_used}
          />
        ) : (
          <ContentDisplay
            data={{
              core_angle: viewItem.generated_core_angle,
              draft: viewItem.generated_draft,
              why_it_works: viewItem.generated_why_it_works,
              alternate_hooks: viewItem.generated_alternate_hooks,
              cta_variations: viewItem.generated_cta_variations,
            }}
            isSaved={true}
            onRepurpose={() => onRepurpose(viewItem)}
            exportMeta={{ title: viewItem.title || viewItem.topic, content_type: viewItem.content_type, platform: viewItem.platform, audience: viewItem.audience, ai_model: viewItem.ai_model_used }}
          />
        )}
      </div>
    </div>
  );
}
